
  export const style={
    inpuStyle:{
      colorInput:"#4D2612"
    },
    url:{
      urlClient:"https://cheirinbao.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_cheirinbao.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Cheirin Coin/Cheirin Coins"
    },
    teamName:{
      name:"Cheirin Bao"
    },
    hasToken: true,
    hostHeader: "cheirinbao"
  }
